export const menuIcon = {
    '/dataBoard': 'icon-shujukanban',
    '/talentScreening': 'icon-renyuanchazhao',
    '/ai/commentAnalysis': 'icon-AIfuzhu-2',
    '/ai/aiAgent': 'icon-AIfuzhu-2',
    '/toBeDone': 'icon-daibanshixiang1',
    '/inventory': 'icon-qingdan',
    '/basicFile': 'icon-jichudangan',
    '/throwInManage': 'icon-toufangluru',
    '/redMan': 'icon-hongrenxitong',
    '/authorityManage': 'icon-quanxian',
    '/financialManage': 'icon-caiwuguanli',
    '/develop': 'icon-ruanjiankaifabao',
    '/rouWen': 'icon-touzidaren-',
    '/adProfessional': 'icon-touliuguanggaowenan',
    '/business': 'icon-daibanshixiang1',
    '/applet': 'icon-jiesuanguanli',
    '/advertisingTracking': 'icon-tongjiyuce',
    '/staffManage': 'icon-yuangongguanli-'
};